import React from 'react';
import Icon from './Icon';
import { colors } from '~/styles';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  font-size: 0.875rem;
  color: ${colors.grey40};
`;

function LockIcon({ ...props }) {
  return <StyledIcon icon="lock" {...props} />;
}

export default LockIcon;
